import styled from 'styled-components';

const icomoonClasses = [
  'print',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'caution',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'content',
  'filter',
  'globe',
  'info',
  'link',
  'theme',
  'thumbs-down-filled',
  'thumbs-down-outlined',
  'thumbs-down',
  'thumbs-up-filled',
  'thumbs-up-outlined',
  'thumbs-up',
  'tip',
  'warning-2',
  'warning',
  'zoom',
];

// https://docsstyleguide.z13.web.core.windows.net/icon-font.html
export type doconNames =
  | 'print'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'caution'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'content'
  | 'filter'
  | 'globe'
  | 'info'
  | 'link'
  | 'theme'
  | 'thumbs-down-filled'
  | 'thumbs-down-outlined'
  | 'thumbs-down'
  | 'thumbs-up-filled'
  | 'thumbs-up-outlined'
  | 'thumbs-up'
  | 'tip'
  | 'warning-2'
  | 'warning'
  | 'zoom'
  // Docons
  | 'more'
  | 'settings'
  | 'people'
  | 'link'
  | 'filter'
  | 'search'
  | 'share'
  | 'lock'
  | 'check-mark'
  | 'delete'
  | 'play'
  | 'calendar'
  | 'enhance-pop'
  | 'flag'
  | 'location-circle'
  | 'home'
  | 'location'
  | 'view'
  | 'download'
  | 'upload'
  | 'dislike'
  | 'like'
  | 'world'
  | 'clock'
  | 'reply'
  | 'clear-night'
  | 'asterisk'
  | 'lightbulb'
  | 'website'
  | 'section'
  | 'developer-tools'
  | 'web-components'
  | 'feedback'
  | 'single-bookmark'
  | 'single-bookmark-solid'
  | 'cloud-import-export'
  | 'text-document'
  | 'arrow-up-right'
  | 'arrow-up8'
  | 'arrow-down8'
  | 'medium-monogram-logo'
  | 'blog'
  | 'deploy'
  | 'more-vertical'
  | 'circle-addition'
  | 'circle-addition-solid'
  | 'file-code'
  | 'asterisk-solid'
  | 'like-solid'
  | 'dislike-solid'
  | 'pod-cast'
  | 'dictionary-download'
  | 'set-history-status'
  | 'reading-settings'
  | 'filter-settings'
  | 'inspect'
  | 'enter-mode'
  | 'wechat'
  | 'weibo'
  | 'brand-linkedin'
  | 'feed'
  | 'check'
  | 'feedback-positive-outline'
  | 'math-multiply'
  | 'octicon-smiley'
  | 'power'
  | 'terminal'
  | 'status-info-outline'
  | 'navigate-refresh'
  | 'sharing'
  | 'exit-mode'
  | 'octicon-issue-closed'
  | 'octicon-issue-opened'
  | 'edit-outline'
  | 'sun'
  | 'locale-globe'
  | 'status-warning-outline'
  | 'status-success-outline'
  | 'brand-facebook'
  | 'brand-github'
  | 'status-error-outline'
  | 'arrow-up-left'
  | 'arrow-right'
  | 'code-lang'
  | 'brand-twitter'
  | 'edit-copy'
  | 'editor-list-bullet'
  | 'octicon-plus-small'
  | 'arrow-down'
  | 'arrow-left'
  | 'status-waiting'
  | 'comment-lines'
  | 'comment-outline'
  | 'mail-message-fill'
  | 'math-minus'
  | 'math-plus'
  | 'math-plus-light'
  | 'user'
  | 'navigate-external'
  | 'play-fill'
  | 'menu'
  | 'navigate-close'
  | 'chevron-up-light'
  | 'chevron-left-light'
  | 'chevron-down-light'
  | 'chevron-right-light'
  | 'status-failure-outline'
  | 'star'
  | 'star-half'
  | 'star-outline'
  | 'topic-architecture'
  | 'topic-deploy'
  | 'topic-download'
  | 'topic-get-started'
  | 'topic-how-to-guide'
  | 'topic-learn'
  | 'topic-overview'
  | 'topic-quickstart'
  | 'topic-tutorial'
  | 'topic-whats-new'
  | 'topic-reference'
  | 'topic-concept'
  | 'topic-video'
  | 'telescope'
  | 'topic-sample'
  | 'question-circle-solid'
  | 'book-solid'
  | 'tag-circle-solid'
  | 'lightbulb-regular'
  | 'brand-dev-to'
  | 'brand-instagram'
  | 'brand-stack-overflow'
  | 'brand-twitch'
  | 'brand-youtube'
  | 'brand-stack-overflow-solid'
  | 'book-open';

export type IconProps = {
  name: iconNames;
  size?: 'default' | 'small' | 'large';
  className?: string;
};

export type iconNames = doconNames;

export const Icon: React.FC<IconProps> = ({ name, size = 'default', className = '' }) => {
  if (icomoonClasses.includes(name)) {
    return <span className={`icon ${className} icomoon size-${size} icon-${name}`} aria-hidden="true"></span>;
  }
  return <span className={`icon ${className} docon size-${size} docon-${name}`} aria-hidden="true"></span>;
};

export default Icon;
